import {
  LoginCallback as OktaLoginCallback,
  useOktaAuth,
} from "@okta/okta-react";
import { useEffect } from "react";

const LoginCallbackPage = () => {
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (authState?.isAuthenticated === true) {
      // Redirect to the original URL or a default route
      const originalUri = oktaAuth.getOriginalUri() || "/";
      window.location.replace(originalUri);
    }
  }, [oktaAuth, authState?.isAuthenticated]);

  return <OktaLoginCallback />;
};
export default LoginCallbackPage;
